// extracted by mini-css-extract-plugin
export default {"tooltip":"Xp-z","sharingV2":"Yp-z","sharingIconsV2":"Zp-z","links":"_p-z","link":"aq-z","facebookV2":"bq-z","twitterV2":"cq-z","pinterestV2":"dq-z"};